
import { ApiService, PurchaseOrderV1Service,PurchaseOrderService ,ApiV1Service } from '../../services'
import { Unauthorized } from '../../helpers/unauthorized.handler'
export const PurchaseOrderV1Module = {
    namespaced: true,
    state: {
        tblKey: 0,
        loading: false,
        Deleteloading: false,
        data: {
            columns: [
                {
                    label: 'Date',
                    field: 'date',
                    sort: 'asc',
                    width: '150',
                },
                {
                    label: 'PO No.',
                    field: 'series',
                    sort: 'asc',
                    clickable: true
                },
                
                {
                    label: 'Reference No.',
                    field: 'vendor_reference',
                    sort: 'asc',
                },
                {
                    label: 'ETA',
                    field: 'eta',
                    sort: 'asc',
                },
                {
                    label: 'Vendor',
                    field: 'vendor_name',
                    sort: 'asc',
                },
                {
                    label: 'Status',
                    field: 'status_label',
                    sort: 'asc',
                },

            ],
            rows: [],
        },
        length: 25,
        page: 0,
        total: 1,
        searchTerm: null,
        filters: {},

        formStatus: 'create',
        formRecord: {},

        Warehouse: [],
        getItemLoading: false,


    },
    actions: {

        

        async GetNextCode({ dispatch }) {
            return await new Promise((resolve) => {
                PurchaseOrderV1Service.get('/code', {}).then((response) => {
                    resolve(response.data)
                }).catch(error => {
                    Unauthorized(dispatch, error)
                })
            })
        },

        async filterItems({ dispatch },params) {
            return await new Promise((resolve) => {
                PurchaseOrderV1Service.get('/filter-item', params).then((response) => {
                    resolve(response.data)
                }).catch(error => {
                    Unauthorized(dispatch, error)
                })
            })
        },
        async getItem({ rootState, commit },params) {
            const { getItemLoading } = rootState.PurchaseOrderModule
            return await new Promise((resolve) => {
                if (!getItemLoading){
                    commit('getItemLoadingTrue');
                    PurchaseOrderV1Service.get(`/item/${params.token_id}`, params).then((response) => {                       
                        commit('SetFormRecord', response.data.data)
                        commit('getItemLoadingFalse')
                        resolve(response.data.data)
                    }).catch(error => {
                        commit('getItemLoadingFalse')
                        Unauthorized(dispatch, error)
                    })
                }
            })
        },

        async asyncGetData({ rootState, commit, dispatch }) {
            const { loading, length, page, filters, searchTerm } = rootState.PurchaseOrderModule
            return await new Promise((resolve) => {
                if (loading === false) {
                    commit('LoadingTrue')
                    const params = { length: length, page: page, term: searchTerm, filters: filters }
                    PurchaseOrderV1Service.get('\/data', params).then((response) => {
                        commit('SetPage', response.data.current_page)
                        commit('SetTotal', response.data.total)
                        commit('SetData', response.data.data)
                        commit('LoadingFalse')
                        resolve(response.data.data)
                    }).catch(error => {
                        //reject(error)
                        Unauthorized(dispatch, error)
                    })
                }
            })
        },



        async sendToGeneralManager({ rootState, commit }, payload) {
            var self = this
            return await new Promise((resolve, reject) => {
                const loading = rootState.PurchaseOrderModule.loading;
                if (!loading) {
                    commit('LoadingTrue')
                    PurchaseOrderService.post('/send-to-general-manager',payload).then((response) => {
                        commit('LoadingFalse')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('LoadingFalse')
                        reject(error)
                    })
                }
            })
        },
        async StoreRecord({ rootState, commit }, payload) {
            var self = this
            return await new Promise((resolve, reject) => {
                const loading = rootState.PurchaseOrderModule.loading;
                if (!loading) {
                    commit('LoadingTrue')
                    PurchaseOrderService.store(payload).then((response) => {
                        commit('LoadingFalse')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('LoadingFalse')
                        reject(error)
                    })
                }
            })
        },
        UpdateRecord({ rootState, commit }, payload) {
            var self = this
            return new Promise((resolve, reject) => {
                const loading = rootState.PurchaseOrderModule.loading;
                if (!loading) {
                    commit('LoadingTrue')
                    ApiV1Service.put(payload).then((response) => {
                        commit('LoadingFalse')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('LoadingFalse')
                        reject(error)
                    })
                }
            })
        },
        updateStatus({ rootState, commit }, { endpoint, payload}) {
            var self = this
            return new Promise((resolve, reject) => {
                const loading = rootState.PurchaseOrderModule.loading;
                if (!loading) {
                    commit('LoadingTrue')
                    PurchaseOrderV1Service.updateStatus(endpoint,payload).then((response) => {
                        commit('LoadingFalse')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('LoadingFalse')
                        reject(error)
                    })
                }
            })
        },
        async DeleteRecord({ rootState, commit }, payload) {
            var self = this
            return await new Promise((resolve, reject) => {
                const loading = rootState.PurchaseOrderModule.Deleteloading;
                if (!loading) {
                    commit('DeleteloadingTrue')
                    const tokens = [];
                    payload.forEach(element => {
                        tokens.push(element.token_id)
                    });
                    ApiService.deleteSelected(tokens).then((response) => {
                        commit('DeleteloadingFalse')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('DeleteloadingFalse')
                        reject(error)
                    })
                }
            })
        }
    },
    mutations: {
        getItemLoadingFalse: (state) => {
            state.getItemLoading = false
        },
        getItemLoadingTrue: (state) => {
            state.getItemLoading = true
        },
        LoadingFalse: (state) => {
            state.loading = false
        },
        LoadingTrue: (state) => {
            state.loading = true
        },
        DeleteloadingFalse: (state) => {
            state.Deleteloading = false
        },
        DeleteloadingTrue: (state) => {
            state.Deleteloading = true
        },
        SetData(state, payload) {
            state.data.rows = payload
        },
        SetPage: (state, payload) => {
            state.page = payload
        },
        SetTotal: (state, payload) => {
            state.total = payload
        },
        SetLength: (state, payload) => {
            state.length = payload
        },
        SetCode: (state, payload) => {
            state.form.item_code = payload
        },

        SetFormStatusCreate: (state) => {
            state.formStatus = 'create'
        },

        SetFormStatusUpdate: (state) => {
            state.formStatus = 'update'
        },
        SetFormRecord: (state, payload) => {
            state.formRecord = payload
        },
        SetItemFormRecord: (state, payload) => {
            state.formRecord = payload
        },
        setWarehouse: (state, payload) => {
            state.Warehouse = payload
        },
        setTblKey: (state, payload) => {
            state.tblKey = payload
        },
    },
    getters: {
        Loading: state => state.loading,
        Deleteloading: state => state.Deleteloading,
        dialogIsOpen: state => state.dialogIsOpen,
        data: state => state.data,
        page: state => state.page,
        total: state => state.total,
        length: state => state.length,
        form: state => state.form,
        columns: state => state.data.columns,
        FormStatus: state => state.formStatus,
        FormRecord: state => state.formRecord,
        Warehouse: state => state.Warehouse,
        getItemLoading: state => state.getItemLoading,
        tblKey: state => state.tblKey,
    }
}


